import React, { useState } from "react";
import MyBookButton from "./MyBookButton";
import ArchiveButton from "./ArchiveBookButton";
import { useTranslation } from "../../context/TranslationContext";
import SectionTabs from "../../component/SectionTabs";

function MyBooks() {
  const [selectedSection, setSelectedSection] = useState("myBooks");
  const { translations, language } = useTranslation();
  const isArabic = language === "ar";

  const handleSelectChange = (event) => {
    setSelectedSection(event.target.value);
  };

  const sections = {
    myBooks: {
      label: translations.myBooks,
    },
    archive: {
      label: translations.archive,
    },
  };

  return (
    <div
      className={`flex ${
        isArabic ? "flex-col md:flex-row" : "flex-col-reverse md:flex-row-reverse"
      } pt-16 w-full`}
    >
      <div
        className="pt-10 flex-1"
        style={{
          fontFamily: "Tajwal, sans-serif",
          direction: isArabic ? "rtl" : "ltr",
          textAlign: isArabic ? "right" : "left",
        }}
      >
        <h2 className="text-xl font-bold mb-1">{translations.libraryTitle}</h2>
        <h4 className="text-l font-bold text-gray-500">
          {translations.continueReading}
        </h4>

        <SectionTabs
          sections={sections}
          selectedSection={selectedSection}
          onChange={handleSelectChange}
        />

        {/* الأزرار للشاشات الأكبر */}
        <div className="hidden sm:flex flex-wrap justify-center md:justify-start mt-4 gap-2">
          <button
            className={`flex items-center px-4 py-2 bg-blue rounded-lg text-l font-bold text-gray-900 hover:bg-primary-blue hover:text-white focus:outline-none ${
              selectedSection === "myBooks" ? "bg-primary-blue text-white" : ""
            }`}
            onClick={() => setSelectedSection("myBooks")}
          >
            {translations.myBooks}
          </button>
          <button
            className={`flex items-center px-4 py-2 bg-blue rounded-lg text-l font-bold text-gray-900 hover:bg-primary-blue hover:text-white focus:outline-none ${
              selectedSection === "archive" ? "bg-primary-blue text-white" : ""
            }`}
            onClick={() => setSelectedSection("archive")}
          >
            {translations.archive}
          </button>
        </div>

        <div className="mt-4">
          {selectedSection === "myBooks" && <MyBookButton />}
          {selectedSection === "archive" && <ArchiveButton />}
        </div>
      </div>
    </div>
  );
}

export default MyBooks;
